import React from 'react';
import { AspectRatio, Flex, Loader, Position, Text } from '@marvelapp/ui';
import CardImage from './CardImage';
import PinCenter from './PinCenter';
export default function Loading(_a) {
    var borderRadius = _a.borderRadius, image = _a.image, imagePadding = _a.imagePadding, ratio = _a.ratio;
    return (React.createElement(AspectRatio, { borderRadius: borderRadius, overflow: "hidden", ratio: ratio }, image ? (React.createElement(Flex, { height: "100%", padding: imagePadding },
        React.createElement(CardImage, { borderRadius: borderRadius, src: image }),
        React.createElement(Position, { bg: "rgba(0, 0, 0, 0.4)", borderRadius: "50%", bottom: 0, m: 1, p: 1, position: "absolute", right: 0 },
            React.createElement(Loader, { color: "white" })))) : (React.createElement(PinCenter, { flexDirection: "column" },
        React.createElement(Loader, { size: 30 }),
        React.createElement(Text, { fontSize: 3, maxWidth: "60%", mt: 2, textAlign: "center" }, "Image uploading...")))));
}
